<template>
  <div class="main-page center-block" :style="{ minHeight: minHeight }">
    <!-- <span>Main Field</span> -->
  </div>
</template>

<script>
export default {
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  created () {
    window.location.href = 'linapp://'
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/main/main.vue